export const EMPTY_ARRAY_LENGTH = 0;
export const HEAD_ELEMENT_INDEX = 0;
export const NOT_FOUND_ELEMENT_INDEX = -1;
